import CountUp from 'react-countup';
export default function CounterUp(){
    return(
        <>
            <section className="counter-area pb-90 pb-md-30 pb-xs-30">
					<div className="container">
						<div className="row counter-borders pt-120 pt-md-60 pt-xs-60">
							<div className="section-title text-center mb-65">
								<p className="lh-1 mb-15">Fun Fact</p>
								<h2 className="sect-title lh-1">2000+ happy impressions</h2>
							</div>
						</div>
						<div className="row align-items-center">
							<div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
								<div className="count-text3 d-flex align-items-center mb-30">
									<div className="counter-content">
										<h3><span className="counter"><CountUp end={100} /></span>+</h3>
										<p className="fs-14">Happy Customers</p>
									</div>
									<div className="icon">
										<img src="assets/img/counter/ic-4.png" alt="Icon" />
									</div>
								</div>
							</div>
							<div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
								<div className="count-text3 d-flex align-items-center mb-30">
									<div className="counter-content">
										<h3><span className="counter"><CountUp end={100} /></span>%</h3>
										<p className="fs-14">Clients Satisfied</p>
									</div>
									<div className="icon">
										<img src="assets/img/counter/ic-5.png" alt="Icon" />
									</div>
								</div>
							</div>
							<div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
								<div className="count-text3 d-flex align-items-center mb-30">
									<div className="counter-content">
										<h3><span className="counter"><CountUp end={6847} /></span>+</h3>
										<p className="fs-14">Happy Customers</p>
									</div>
									<div className="icon">
										<img src="assets/img/counter/ic-6.png" alt="Icon" />
									</div>
								</div>
							</div>
							<div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
								<div className="count-text3 d-flex align-items-center mb-30">
									<div className="counter-content">
										<h3><span className="counter"><CountUp end={100} /></span>%</h3>
										<p className="fs-14">Clients Satisfied</p>
									</div>
									<div className="icon">
										<img src="assets/img/counter/ic-7.png" alt="Icon" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
        </>
    )
}